import { api } from './api';
import {
  GenerationRunListResponse,
  GenerationRunStats,
  StandingOrderAutoGenerationSetting,
  GenerationRunTriggerType,
} from '@mygate/common';

class AutoGenerationService {
  /**
   * Get kill switch state
   */
  async getAutoGenerationSetting() {
    const response = await api.get<StandingOrderAutoGenerationSetting>(
      '/api/staff/system-settings/standing-order-auto-generation',
    );
    return response.data;
  }

  /**
   * Toggle kill switch
   */
  async toggleAutoGeneration(enabled: boolean) {
    const response = await api.post<StandingOrderAutoGenerationSetting>(
      '/api/staff/system-settings/standing-order-auto-generation',
      { enabled },
    );
    return response.data;
  }

  /**
   * Get generation runs with pagination
   */
  async getGenerationRuns(params?: {
    page?: number;
    limit?: number;
    fromDate?: string;
    toDate?: string;
    triggerType?: GenerationRunTriggerType;
  }) {
    const searchParams = new URLSearchParams();

    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());
    if (params?.fromDate) searchParams.append('fromDate', params.fromDate);
    if (params?.toDate) searchParams.append('toDate', params.toDate);
    if (params?.triggerType) searchParams.append('triggerType', params.triggerType);

    const queryString = searchParams.toString();
    const endpoint = `/api/staff/generation-runs${queryString ? `?${queryString}` : ''}`;

    const response = await api.get<GenerationRunListResponse>(endpoint);
    return response.data;
  }

  /**
   * Get generation run stats
   */
  async getGenerationRunStats() {
    const response = await api.get<GenerationRunStats>('/api/staff/generation-runs/stats');
    return response.data;
  }
}

export const autoGenerationService = new AutoGenerationService();
